module.exports = __webpack_public_path__ + "img/company_qualification.8128c888.png";